import { makeDropzone, compose } from '../../dependencies';

import DropArea from '../../components/Fields/Attachment/DropArea';

export default compose(makeDropzone)(DropArea);
